module.exports = __webpack_public_path__ + "static/img/two_center.fa45d37a.png";